import { CircularProgress, Stack, Typography } from "@wealthx/ui";
import React from "react";
import "./step-progress-indicator.scss";

import { LookupStep } from "../../type/chat";

const formatAgentName = (agentName: string): string => {
  return agentName
    .replace(/^wealthx_/, "")
    .replace(/_agent$/, "")
    .replace(/_/g, " ");
};

interface StepProgressIndicatorProps {
  step: LookupStep;
}

const StepProgressIndicator: React.FC<StepProgressIndicatorProps> = ({ step }) => {
  const getDisplayText = (): string => {
    if (step.agentName) {
      return `Consulting ${formatAgentName(step.agentName)}...`;
    }
    const isPolicySearch =
      step.name === "policy:search" || step.displayKey === "lookup.step.policy.search";
    const isPolicySynthesize =
      step.name === "policy:synthesize" || step.displayKey === "lookup.step.policy.synthesize";

    if (step.name?.startsWith("policy:") || isPolicySearch || isPolicySynthesize) {
      const bankName = step.metadata?.bankName;
      if (isPolicySearch) {
        return bankName ? `Searching ${bankName} policies...` : "Searching policies...";
      }
      if (isPolicySynthesize) {
        return "Analyzing policy information...";
      }
    }

    const displayTextMap: Record<string, string> = {
      "lookup.step.triage": "Analyzing your question...",
      "lookup.step.orchestrate": "Routing to the appropriate agent...",
      "lookup.step.synthesize": "Generating response...",
      "lookup.step.policy.search": "Searching policies...",
      "lookup.step.policy.synthesize": "Analyzing policy information...",
    };
    return displayTextMap[step.displayKey] || step.displayKey;
  };

  let stepKey = step.name;
  if (step.agentName) {
    stepKey = `${step.name}-${step.agentName}`;
  } else if (step.metadata?.bankName) {
    stepKey = `${step.name}-${step.metadata.bankName}`;
  }

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" className="step-progress-indicator">
      <CircularProgress size={16} thickness={4} />
      <Typography key={stepKey} variant="body2" className="step-progress-indicator__text">
        {getDisplayText()}
      </Typography>
    </Stack>
  );
};

export default StepProgressIndicator;
